import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findCustomerClassify = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/system_classify?` + params,
        method: 'GET'
    })
}
export const findClassifySelect = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/system_classify/select`,
        method: 'GET'
    })
}
export const addSystemClassify = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/system_classify`,
        method: 'POST',
        data: params
    })
}
export const editSystemClassify = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/system_classify`,
        method: 'PUT',
        data: params
    })
}
export const delSystemClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/system_classify/${id}`,
        method: 'DELETE',
    })
}